import React from 'react';
import classnames from 'classnames';
import { Price } from 'src/components/Helpers/Price';
import { SetupFeeLabel, SummarySkeleton } from 'src/components/Basket/BasketTotalsSegments';

import classes from './Inventory.scss';

type Props = {
    inventory: any[];
};

export const Inventory: React.FC<Props> = ({ inventory }) => (
    <div>
        {inventory ? (
            inventory.map((item) => {
                const [title, amount, key, trait] = item;
                const [titlePartOne, titlePartTwo] = title.split(',');

                return (
                    <div
                        className={classnames(classes.row, {
                            [classes.rowBold]: trait === 'bold' || trait === 'total',
                        })}
                        key={title}
                        data-test-id={key}
                        data-key={key}
                    >
                        <span className={classes.titleContainer}>
                            {trait === 'tooltip' ? (
                                <SetupFeeLabel />
                            ) : (
                                <span>
                                    {titlePartOne} <small>{titlePartTwo}</small>
                                </span>
                            )}
                        </span>
                        <span
                            className={classnames(classes.costContainer, {
                                [classes.summary]: trait === 'total',
                                [classes.discount]: trait === 'discount',
                            })}
                        >
                            <Price priceIncl={amount} price={amount} />
                        </span>
                    </div>
                );
            })
        ) : (
            <SummarySkeleton />
        )}
    </div>
);
